import * as React from 'react'
import { IconButtonSeeker } from 'ui-seeker/core'



export default function IconGroupReports({ idLineSelected, setOpenModalReportGroupName, setReportsSelected }) {

	const handleClick = () => {
        setReportsSelected(idLineSelected)
        setOpenModalReportGroupName(true)
	}

	return <IconButtonSeeker icon="layer-group" tooltipPosition="top-right" iconType="fontAwesome" title="Set reports group" onClick={handleClick} />
}